/**
 * Store API helpers.
 */

export async function getStoreItems() {
  const res = await fetch('/api/store/items', { credentials: 'include' });
  if (!res.ok) throw new Error('Failed to fetch store items');
  return res.json();
}

export async function getStoreItem(itemId) {
  const res = await fetch(`/api/store/items/${itemId}`, { credentials: 'include' });
  if (!res.ok) throw new Error('Failed to fetch item');
  return res.json();
}

export async function getOrders() {
  const res = await fetch('/api/store/orders', { credentials: 'include' });
  if (!res.ok) throw new Error('Failed to fetch orders');
  return res.json();
}

export async function createOrder(storeItemId, quantity = 1, shippingAddressId = null) {
  const res = await fetch('/api/store/orders', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      store_item_id: storeItemId,
      quantity,
      shipping_address_id: shippingAddressId,
    }),
    credentials: 'include',
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || 'Failed to create order');
  }
  return res.json();
}

export async function createCheckoutSession(storeItemId, quantity, shippingAddressId, postcard = null) {
  const body = {
    store_item_id: storeItemId,
    quantity,
    shipping_address_id: shippingAddressId ?? null,
  };
  if (postcard) {
    body.postcard = postcard;
  }
  const res = await fetch('/api/store/checkout', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    credentials: 'include',
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || 'Failed to create checkout');
  }
  return res.json();
}

export async function confirmCheckoutSession(sessionId) {
  const res = await fetch('/api/store/checkout/confirm', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ session_id: sessionId }),
    credentials: 'include',
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || 'Failed to confirm checkout');
  }
  return data;
}

/** @param {string} token - postcard claim_token from QR or link */
export async function claimPostcard(token) {
  const res = await fetch('/api/store/postcards/claim', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token }),
    credentials: 'include',
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || 'Failed to claim postcard');
  }
  return data;
}

export async function getShippingAddresses() {
  const res = await fetch('/api/store/addresses', { credentials: 'include' });
  if (!res.ok) throw new Error('Failed to fetch addresses');
  return res.json();
}

export async function addShippingAddress(address) {
  const res = await fetch('/api/store/addresses', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(address),
    credentials: 'include',
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || 'Failed to add address');
  }
  return res.json();
}
